import script from "./SignatureItemMakerCart.vue?vue&type=script&setup=true&lang=js"
export * from "./SignatureItemMakerCart.vue?vue&type=script&setup=true&lang=js"

import "./SignatureItemMakerCart.vue?vue&type=style&index=0&id=42d8da5e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42d8da5e"]])

export default __exports__